export const CONTRACT_LIST = 'contract_list'
export const GATE_LIST = 'gate_list'
export const MAPPED_MATERIAL = 'mapped_material'
export const BARCODE_HISTORY = 'barcode_history'
export const ASSETS_VERIFICATION = 'assets_verification'